import api from '@/api';
import querystring from 'querystring';

export const nbPolicyList = formData => api.post('/b2b/new_business', formData);
export const nbPolicyDetail = caaId =>
  api.get(`/b2b/policy_detail/${caaId}.html`);
export const clientsList = formData => api.post(`/b2b/clients`, formData);
export const policyStatement = partyId => api.get(`/statement/${partyId}.html`);
export const consolidateStatement = (partyId, currency) =>
  api.get(
    `/statement/consolidate_statement/${partyId}.html?selected_currency=${currency}`
  );
export const policyList = partyId =>
  api.get(`/statement/policy_list/${partyId}`);
export const srPolicyList = formData =>
  api.post('/b2b/service_records', formData);

export const srFollowupType = () => api.get('/b2b/get_all_followup_type');

export const srDetail = followupId =>
  api.get(`/b2b/service_record_detail/${followupId}.html`);

export const producerProfile = producerId =>
  api.get(`/b2b/profile/${producerId}`, {
    baseURL:
      process.env.REACT_APP_API_ENDPOINT +
      (process.env.REACT_APP_ENABLE_REI === 'true' ? '/rei' : ''),
  });

export const producerMdrt = producerId =>
  api.get(`/b2b/mdrt/${producerId}`, {
    baseURL: `${process.env.REACT_APP_API_ENDPOINT}/rei`,
  });

export const footer = lang =>
  api.post(
    `${process.env.REACT_APP_API_VENDOR}/b2b/api/getFooter.php`,
    querystring.stringify({Lang: lang})
  );
export const header = formData =>
  api.post(
    `${process.env.REACT_APP_API_VENDOR}/b2b/api/getHeader.php`,
    querystring.stringify(formData)
  );
